import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  AnalyticsAdminSettingUpdate,
  AnalyticsAdminSettingsAction,
  AnalyticsAdminSettingsUpdateAction,
  AnalyticsAdminSettingsUpdateRejectedAction,
} from '../../domains/analyticsAdminSettings/actions.types';

import { AnalyticsAdminSettingsLifecycle } from './types';

const initialState: AnalyticsAdminSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const updateFulfilledAnalyticsAdminSettingWithNewValue = (
  state: AnalyticsAdminSettingsLifecycle,
  payload: AnalyticsAdminSettingUpdate
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.settingProp]: payload.settingValue },
});

const updateFulfilledAnalyticsAdminSettingWithPreviousValue = (
  state: AnalyticsAdminSettingsLifecycle,
  payload: AnalyticsAdminSettingsUpdateRejectedAction['payload']
) => ({
  ...state,
  fulfilled: { ...state.fulfilled, [payload.settingPair.settingProp]: payload.prevSettingValue },
});

const reducer: Reducer<
  AnalyticsAdminSettingsLifecycle,
  AnalyticsAdminSettingsAction | AnalyticsAdminSettingsUpdateAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'ANALYTICS_ADMIN_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'ANALYTICS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_PENDING':
      return updateFulfilledAnalyticsAdminSettingWithNewValue(state, action.payload);
    case 'ANALYTICS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_REJECTED':
      return updateFulfilledAnalyticsAdminSettingWithPreviousValue(state, action.payload);
    case 'ANALYTICS_ADMIN_SETTINGS.UPDATE_SETTING_VALUE_FULFILLED':
      return updateFulfilledAnalyticsAdminSettingWithNewValue(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
